import { PRODUCTOS } from '../constants/productos';
import { fmtMoney } from './money';

export const fmtQty = (qty) => qty % 1 !== 0 ? qty.toFixed(1) : String(qty);

const SEP = '================================';

export function buildTicketText({ titulo = 'TICKET DE VENTA', infoLines = [], productos, preciosSnapshot, pagoLabel, footerLines = ['Gracias por su compra'] }) {
  let lines = `${SEP}\n   ${titulo}\n${SEP}\n`;
  for (const l of infoLines) lines += `${l}\n`;
  lines += `${SEP}\n`;
  lines += `PRODUCTO           CANT   PRECIO     TOTAL\n`;
  lines += `------------------------------------------\n`;
  let total = 0;
  for (const prod of PRODUCTOS) {
    const qty = productos[prod.clave] || 0;
    if (!qty) continue;
    const precio = Number(preciosSnapshot[prod.clave] || 0);
    const subtotal = Math.round(precio * qty * 100) / 100;
    total += subtotal;
    const nombre = prod.nombre.padEnd(18).slice(0, 18);
    const cantStr = fmtQty(qty).padStart(4);
    const precioStr = fmtMoney(precio).padStart(10);
    const subtotalStr = fmtMoney(subtotal).padStart(11);
    lines += `${nombre} ${cantStr} ${precioStr} ${subtotalStr}\n`;
  }
  lines += `------------------------------------------\n`;
  lines += `TOTAL:                        ${fmtMoney(total)}\n`;
  if (pagoLabel) lines += `Pago:  ${pagoLabel}\n`;
  lines += `${SEP}\n`;
  for (const l of footerLines) lines += `  ${l}\n`;
  return lines;
}

export function sendTicketToBridge(prefs, content) {
  return new Promise((resolve) => {
    if (!prefs.printerEnabled || !prefs.printerIp?.trim() || !prefs.bridgeUrl?.trim()) { resolve(false); return; }
    const bridge = prefs.bridgeUrl.trim().replace(/\/$/, '');
    const xhr = new XMLHttpRequest();
    xhr.open('POST', `${bridge}/`, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.timeout = 6000;
    xhr.onloadend = () => resolve(true);
    xhr.onerror = () => resolve(false);
    xhr.ontimeout = () => resolve(false);
    xhr.send(JSON.stringify({ ip: prefs.printerIp.trim(), port: parseInt(prefs.printerPort) || 9100, content }));
  });
}
